import { jsx as o } from "react/jsx-runtime";
const i = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...r,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        d: "m12.294 9.853 1.67-.447-5.912-5.913-3.128.408-2.355-2.354-1.06 1.06 2.355 2.355-.409 3.127 6.364 6.364 2.924-2.924-.449-1.676Zm-2.475 2.479L5.038 7.551 5.201 6.3l.927.927 1.673-.448-1.539-1.54 1.251-.162 4.781 4.78-2.475 2.476v-.001Z"
      }
    )
  }
);
export {
  i as Pricing
};
